import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
    const { googleLogin } = useAuth();
    const nav = useNavigate();
    const ran = useRef(false);
    const [status, setStatus] = useState("Signing you in…");

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        // Try fragment first (Emergent standard), then query string as fallback
        const hash = window.location.hash || "";
        const search = window.location.search || "";
        const hashParams = new URLSearchParams(hash.replace(/^#/, ""));
        const qsParams = new URLSearchParams(search.replace(/^\?/, ""));
        const sessionId = hashParams.get("session_id") || qsParams.get("session_id");
        if (!sessionId) {
            setStatus("Missing session — redirecting…");
            toast.error("No session found in redirect URL");
            setTimeout(() => nav("/login"), 1200);
            return;
        }
        (async () => {
            try {
                await googleLogin(sessionId);
                toast.success("Signed in with Google");
                nav("/app/dashboard", { replace: true });
            } catch (err) {
                setStatus("Sign-in failed — redirecting…");
                toast.error(err?.response?.data?.detail || "Google sign-in failed");
                setTimeout(() => nav("/login", { replace: true }), 1200);
            }
        })();
    }, [googleLogin, nav]);

    return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center">
            <div className="font-mono-ui text-xs tracking-[0.25em] uppercase text-zinc-400" data-testid="auth-callback-status">// {status}</div>
        </div>
    );
}
